import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContainerError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #fff;

  img {
    height: 10rem;
  }

  strong {
    margin: 1.6rem 0;
    font-size: 2.8rem;
  }

  p {
    font-size: 1.6rem;
    margin-bottom: 1.6rem;
  }
`;
